<!-- 首页 -->
<template>
  <div class="home-index">
    <img class="item-img" v-show="item.img" :src="item.img" alt="" />
    <div class="item-content1">
      <h4>{{ item.name }}</h4>
      <div class="item-test">
        <img src="../../assets/addr-icon.png" alt="" />
        <span>机构地址：</span>
        <div>{{ item.adder }}</div>
      </div>
      <div class="item-test">
        <img src="../../assets/time-icon.png" alt="" />
        <span>营业时间：</span>
        <div>{{ item.openTime }}</div>
      </div>
      <a :href="`tel:` + item.tel" class="tel_btn2" alt="" />
    </div>
    <div class="item-content2" v-show="item.info">
      <h4>机构简介</h4>
      <div>{{ item.info }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      item: "",
    };
  },

  activated() {
    this.item = JSON.parse(sessionStorage.getItem("czServiceInfo"));
  },

  created() {
    document.title = "机构详情";
    if (this.$eshimin) {
      this.$eshimin.setTitle({
        title: "机构详情",
        onResponse: function (res) {
          console.log("setTitle res:" + res);
        },
      });
    }
  },

  mounted() {},

  methods: {},

  filters: {},

  watch: {},

  //离开路由，不可截停
  destroyed() {},

  //离开路由，可截停
  beforeRouteLeave(to, from, next) {
    next();
  },
};
</script>

<style lang="less" scoped>
//显示一行，超出省略号
.show-text-1 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
//显示多行，超出省略号
.show-text-num(@num) {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: @num;
  overflow: hidden;
  word-break: break-all;
}
// 抛弃行高，文字居中写法全居中
.all_center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-index {
  height: 100%;
  width: 100%;
  background: #f4f6f8;
  font-size: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.item-img {
  width: 100%;
  height: auto;
}
.item-content1 {
  border-radius: 8px;
  background: #fff;
  margin: 15px;
  padding: 12px;
  h4 {
    font-size: 16px;
    margin-bottom: 12px;
    font-weight: 600;
    line-height: 22.5px;
  }
}
.item-test {
  display: flex;
  margin-bottom: 10px;
  img {
    width: 16px;
    height: 16px;
    margin-top: 2px;
  }
  span {
    display: inline-block;
    width: 70px;
    color: #333;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    margin-left: 5px;
    flex: none;
  }
  div {
    color: #666;
    font-size: 14px;
    line-height: 20px;
  }
}
.tel_btn2 {
  display: block;
  width: 100%;
  height: 40px;
  margin-top: 25px;
  background: url("../../assets/tel_btn2.png");
  background-size: 100% 100%;
}
.item-content2 {
  margin: 10px 15px 15px 15px;
  padding: 12px;
  border-radius: 8px;
  background: #fff;
  h4 {
    color: #333;
    font-weight: 600;
    font-size: 16px;
  }
  div {
    color: #666;
    font-size: 14px;
    font-weight: 400;
    margin-top: 15px;
  }
}
</style>